import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import { getPartnerGuid, hasAuthourity } from '../../../../../lib/access.es6';
import { ClaimActionEnum } from '../../../lib/enum';
import ModalInc from '../../../../../shared-ui/ModalInc';
import { TextValidator, ValidatorForm, SelectValidator } from 'react-material-ui-form-validator';
import MenuItem from '@material-ui/core/MenuItem';

const OMM_REJECTION_REASONS = [
  'Policy lapse',
  'Policy in reinstatement',
  'Waiting period',
  'Dependent not on the list',
  'Fraudulent claim',
  'Other',
];

const DecisionPending = (props) => {
  const [toggleLoading, setToggleLoading] = React.useState('btn1')
  const [showModal, setShowModal] = React.useState(false);
  const [rejectionReason, setRejectionReason] = React.useState('');
  const [otherReason, setOtherReason] = React.useState('');
  const classes = useStyle();

  const isOmkPartner = getPartnerGuid() === 'omk';
  const isOmmPartner = getPartnerGuid() === 'old_mutual_malawi';

  const handleApproveClaim = () => {
    if (props.claim.is_waiting_period) {
      props.toggleWaitingPeriodApprovedDialog(true)
    } else {
      setToggleLoading('btn1');
      props.submitClaimAction({
        claim_action: ClaimActionEnum.approve,
        claim_guid: props.claim.guid,
      });
    }
  }

  const handleRejectClaim = () => {
    if (isOmkPartner || isOmmPartner) {
      setShowModal(true);
      return;
    }
    setToggleLoading('btn2')
    props.submitClaimAction({
      claim_action: ClaimActionEnum.reject,
      claim_guid: props.claim.guid,
    })
  }

  const handleModalSubmit = () => {
    const finalReason = rejectionReason === 'Other' ? otherReason : rejectionReason;
    setToggleLoading('btn2');
    props.submitClaimAction({
      claim_action: ClaimActionEnum.reject,
      claim_guid: props.claim.guid,
      body: { rejection_reason: finalReason }
    });
    setShowModal(false);
    setRejectionReason('');
    setOtherReason('');
  };

  const handleModalClose = () => {
    setShowModal(false);
    setRejectionReason('');
    setOtherReason('');
  };

  return (
    <section className={classes.ClaimActionButtons}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ButtonInc onClick={handleApproveClaim} hasPermision={hasAuthourity('APPROVE_CLAIM')} loading={props.loading && toggleLoading === 'btn1'} variant="contained" style={{ width: "221px", height: "55px", float: "left", marginRight: "20px" }}>Approve Claim</ButtonInc>
          <ButtonInc onClick={handleRejectClaim} hasPermision={hasAuthourity('REJECT_CLAIM')} loading={props.loading && toggleLoading === 'btn2'} variant="contained" style={{ width: "221px", height: "55px", background: "#8F191C" }}>Reject Claim</ButtonInc>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <p style={{ color: 'red' }}>{props.error ? props.error.message : ''}</p>
        </Grid>
      </Grid>

      <ModalInc
        modalTitle="Rejection Reason"
        subTitle="Fill the below field to add reason on why you are rejecting this claim"
        open={showModal}
        onClose={handleModalClose}
        fullWidth
      >
        <ValidatorForm onSubmit={handleModalSubmit}>
          <Grid container spacing={2}>
            {isOmmPartner ? (
              <>
                <Grid item xs={12} sm={12} md={12}>
                  <SelectValidator
                    name='rejectionReason'
                    id="rejectionReason"
                    label="Rejection Reason"
                    value={rejectionReason}
                    onChange={e => setRejectionReason(e.target.value)}
                    fullWidth
                    variant="outlined"
                    validators={['required']}
                    errorMessages={['Please select a rejection reason']}
                  >
                    {OMM_REJECTION_REASONS.map(function(reason) {
                      return <MenuItem key={reason} value={reason}>{reason}</MenuItem>
                    })}
                  </SelectValidator>
                </Grid>
                {rejectionReason === 'Other' && (
                  <Grid item xs={12} sm={12} md={12}>
                    <TextValidator
                      name='otherReason'
                      id="otherReason"
                      label="Please specify"
                      value={otherReason}
                      onChange={e => setOtherReason(e.target.value)}
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      validators={['required']}
                      errorMessages={['Please enter the rejection reason']}
                    />
                  </Grid>
                )}
              </>
            ) : (
              <Grid item xs={12} sm={12} md={12}>
                <TextValidator
                  name='rejectionReason'
                  id="rejectionReason"
                  multiline
                  rows={5}
                  maxRows={4}
                  label="Rejection Reason"
                  value={rejectionReason}
                  onChange={e => setRejectionReason(e.target.value)}
                  fullWidth
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter Rejection Reason']}
                />
              </Grid>
            )}
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} style={{ textAlign: 'center' }}>
                  <ButtonInc
                    size="large"
                    onClick={handleModalClose}
                    type="button"
                    variant="contained"
                    style={{ width: "221px", height: "55px", background: "#FBA92D", marginTop: '3%' }}
                  >Cancel</ButtonInc>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                    style={{ width: "221px", height: "55px", background: "#FBA92D", marginTop: '3%' }}
                    disabled={!rejectionReason || (rejectionReason === 'Other' && !otherReason)}
                  >
                    Submit
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ModalInc>
    </section>
  )
}

export default DecisionPending